import React, { useState } from "react";
import "./contact.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const url = "https://educationoncloud.in/api/equinox_appointment_details.php";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^\d{10}$/;

function Contact({ show, onClose }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  if (!show) return null;
  const submitForm = async (e) => {
    e.preventDefault();

    const errors = [];
    if (name === "" && email === "" && phone === "") {
      toast.error("All fields are Required");
      return;
    }
    if (!name.trim()) errors.push("Name is required");
    if (!phoneRegex.test(phone)) errors.push("Mobile number must be 10 digits");
    if (!email) errors.push("Please enter Email!");
    if (!emailRegex.test(email)) errors.push("Invalid email format");

    if (errors.length > 0) {
      toast.error(errors.join(" | "));
      return;
    }

    try {
      const response = await axios.post(url, {
        fullname: name,
        mobileno: phone,
        email: email,
        message: message,
      });
      toast.success("Form submitted successfully!");
      resetFrom();
    } catch (error) {
      toast.error("Something went wrong while submitting");
    }
  };



  const resetFrom = () => {
    setName("");
    setEmail("");
    setPhone("");
    setMessage("");
  };



  return (
    <div className="modal-backdrop">
      <div className="modal-box">
        <div onClick={onClose} className="close-container">
          <img
            src="https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/close-icon.png"
            alt="Close"
          />
        </div>
        <div className="contact-container">
          <div className="contact-left-container">
            <h5 className="contact-heading">Contact Us</h5>
            <h2 className="make-appoinment">Make an Appointment</h2>

            <form className="form-container" onSubmit={(e) => submitForm(e)}>
              <div className="nameandphone">
                <input
                  type="text"
                  placeholder="Full Name*"
                  value={name}
                  className="input-field"
                  onChange={(e) => setName(e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Phone*"
                  value={phone}
                  className="input-field"
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
              <input
                type="text"
                placeholder="Email*"
                value={email}
                className="input-field-email"
                onChange={(e) => setEmail(e.target.value)}
              />
              <textarea
                style={{ paddingTop: "4%", height: "100px" }}
                placeholder="Message"
                className="input-field-email text-area-message"
                onChange={(e) => setMessage(e.target.value)}
                value={message}
              ></textarea>
              <button type="submit" className="button-send">
                Send
              </button>
              <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
              />
            </form>
          </div>
          <div className="contact-right-container">
            <iframe
              className="map-image"
              title="Equinox Tech Solutions Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3890.858063132203!2d77.6079567!3d12.9666434!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae156d1f327a13%3A0xe2dfe432b3075b73!2sEquinox%20Tech%20Solutions!5e0!3m2!1sen!2sin!4v1721890292757!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Contact;
